import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const ResetPassword = () => {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const token = params.get("token") || "";

    const submit = async (e) => {
        e.preventDefault();
        if (!token) return toast.error("Missing token");
        setLoading(true);
        try {
            await api.post("/auth/reset-password", { token, new_password: password });
            toast.success("Password updated. Please log in.");
            navigate("/login");
        } catch (e) {
            toast.error("Reset failed — link may be expired.");
        } finally { setLoading(false); }
    };

    return (
        <div className="min-h-[calc(100vh-6rem)] flex items-center justify-center px-6 py-10">
            <div className="w-full max-w-md rounded-4xl glass-strong p-8 text-center">
                <div className="mx-auto w-14 h-14 rounded-full bg-primary/10 text-primary flex items-center justify-center mb-4"><KeyRound className="w-6 h-6" /></div>
                <h1 className="font-display text-2xl font-bold">Set a new password</h1>
                <form onSubmit={submit} className="mt-6 space-y-3">
                    <Input required type="password" placeholder="New password (min 6)" value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-xl h-12 bg-white/60" />
                    <Button type="submit" disabled={loading} className="w-full rounded-full h-12 bg-primary hover:bg-primary/90">{loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Reset password"}</Button>
                </form>
                <div className="mt-5 text-sm"><Link to="/login" className="text-primary hover:underline">Back to login</Link></div>
            </div>
        </div>
    );
};

export default ResetPassword;
